export const CANCELLATION_REASON_VENDOR_NO_QUOTE =
  'Vendor did not provide quote during expected time window';

export const CANCELLATION_REASON_ALL_QUOTES_EXPIRED = 'ALL_QUOTES_EXPIRED';
export const CANCELLATION_REASON_REANALYSIS_APPROVAL_EXPIRED =
  'REANALYSIS_APPROVAL_EXPIRED';
export const CANCELLATION_REASON_MANUALLY_CANCELLED =
  'AZ Translate Tool - User has manually cancelled vendor order.';
export const CANCELLATION_REASON_REJECTED_UPDATED_VENDOR_QUOTE =
  'AZ Translate Tool - User has rejected the updated vendor quote.';
export const CANCELLATION_REASON_REJECTED_UPDATED_FINAL_COST =
  'Requestor rejected the vendor’s updated final cost.';

export const CANCELLATION_REASON_DISPLAY_MAP: Readonly<Record<string, string>> =
  {
    [CANCELLATION_REASON_VENDOR_NO_QUOTE]:
      'Vendors did not provide quote during expected time window',
    [CANCELLATION_REASON_ALL_QUOTES_EXPIRED]: 'All vendor quotes expired.',
    [CANCELLATION_REASON_REANALYSIS_APPROVAL_EXPIRED]:
      'A revised cost estimate was provided, but no response was received before the quote expired. Please request a new quote to proceed',
    [CANCELLATION_REASON_MANUALLY_CANCELLED]:
      'The user manually cancelled the job',
  };

export function formatCancellationReason(
  reason: string | null | undefined,
  hasReanalysis = false,
): string {
  const trimmed = reason?.trim() ?? '';
  if (trimmed.length === 0) {
    return '';
  }

  if (
    hasReanalysis &&
    trimmed === CANCELLATION_REASON_REJECTED_UPDATED_VENDOR_QUOTE
  ) {
    return CANCELLATION_REASON_REJECTED_UPDATED_FINAL_COST;
  }

  return CANCELLATION_REASON_DISPLAY_MAP[trimmed] ?? trimmed;
}
